<!-- @format -->

<template>
  <div>
    <DashHeader />
  </div>
</template>

<script setup>
import DashHeader from "@/components/newUi/baseComponents/DashHeader.vue";
</script>
